

const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:3,
            blockcomponents: {
                columns: [
                    //left column
                    [
                       
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Rezept/Zutat Name",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'entities/ENTITY_SET_NAME',
                                    rules:"required"
                            }
                        }, 
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Kategorie",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:false,
                                icon:"search",
                                variable: 'entitycategory_id',
                                setter: 'entities/ENTITY_SET_ENTITYCATEGORY',
                                items:'entitycategories/entitycategories',
                                withdialog:false,
                                rules:"required"
                            }                                    
                        }
                    ], 
                    //right column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Number",
                                    size:"xs5",
                                    invertedsize:"xs6",
                                    hint:"Nummer",
                                    icon:"edit",
                                    variable: 'number',
                                    setter: 'entities/ENTITY_SET_NUMBER'
                            }
                        },  
                       {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Spezifikation",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:false,
                                icon:"search",
                                variable: 'specification_id',
                                setter: 'entities/ENTITY_SET_SPECIFICATION',                                    
                                items:'specifications/specifications',
                                withdialog:true,
                            }                                    
                        },
                                                                                              
                    ],  
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Lieferant",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"web",
                                multiple:false,
                                icon:"search",
                                variable: 'supplier_id',
                                setter: 'entities/ENTITY_SET_SUPPLIER',
                                items:'companies/supplier',
                                withdialog:false,
                            }                                    
                        },
                        
                    ]
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};

                     
                    